import { useState, useEffect, useCallback } from "react";
import { FaSearch, FaEdit, FaPlus, FaRegTrashAlt } from 'react-icons/fa';
import SideNave from "../common/sidenav";
import TopNav from "../common/topnav";
import DataTable from 'react-data-table-component';
import '../common/style.css';
import './bank.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { showImage, deleteBankDataByID, showBankPayment } from "../http/api"; // Import deleteBankDataByID API
import Loading from "../loading/loading";
import { useAuth } from "../http/authcontex";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaCopy } from "react-icons/fa6";

export default function ShowBanks() {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const authContext = useAuth();
    const location = useLocation();

    const [isSidebarOpen, setIsSidebarOpen] = useState(
        localStorage.getItem('sb|sidebar-toggle') === 'true'
    );

    const [bankDetails, setBank] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredUsers, setFilteredUsers] = useState([]);

    // Modal state for deletion confirmation
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [bankToDelete, setBankToDelete] = useState(null);

    useEffect(() => {
        localStorage.setItem('sb|sidebar-toggle', isSidebarOpen);
    }, [isSidebarOpen]);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        localStorage.setItem('sb|sidebar-toggle', !isSidebarOpen);
    };

    useEffect(() => {
        console.log('location.state ' + location.state);

        if (location.state?.success) {
            toast.success("Bank details submitted successfully!", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                style: {
                    border: "3px solid green",
                    borderRadius: "8px",
                    padding: "10px",
                    bottom: "-45px",
                }
            });
        }
    }, [location.state]);

    const viewBankData = useCallback(() => {
        setLoading(true);
        showBankPayment()
            .then(async (response) => {
                if (response.status === 200) {
                    const bankData = response.data.map((item) => ({
                        bankid: item.bankid,
                        bankName: item.bankName,
                        bankLogo: item.logo, // Store raw byte code
                        branchName: item.branchName,
                        city: item.city,
                        address: item.address,
                        invoiceAmount: item.invoiceAmount,
                        paidAmount: item.paidAmount,
                        dueAmount: item.dueAmount

                    }));

                    // Fetch and convert bytecode images to URLs
                    const bankDataWithImages = await Promise.all(
                        bankData.map(async (bank) => {
                            if (bank.bankLogo) {
                                try {
                                    const response = await showImage(bank.bankLogo);
                                    if (response.status === 200 || response.status === 202) {
                                        const blob = new Blob([response.data], {
                                            type: response.headers['content-type'],
                                        });
                                        const imageUrl = URL.createObjectURL(blob);
                                        bank.bankLogo = imageUrl; // Save the image URL
                                    }
                                } catch (error) {
                                    console.error(`Error fetching image for bank ID ${bank.id}:`, error);
                                    bank.bankLogoUrl = null; // Fallback in case of error
                                }
                            } else {
                                bank.bankLogoUrl = null;
                            }
                            return bank;
                        })
                    );

                    setBank(bankDataWithImages);
                    setLoading(false);
                }
            })
            .catch((error) => {
                setLoading(false);
                if (error.response && error.response.status === 401) {
                    console.error("Unauthorized access, redirecting to login...");
                    authContext.logout();
                    navigate('');
                } else {
                    console.error("Error fetching bank details:", error);
                }
            });
    }, [authContext, navigate]);

    useEffect(() => {
        viewBankData();
    }, [viewBankData]);

    useEffect(() => {
        const filtered = bankDetails.filter((bank) =>
            Object.values(bank).some(
                (value) =>
                    typeof value === "string" &&
                    value.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
        setFilteredUsers(filtered);
    }, [searchTerm, bankDetails]);

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleAdd = () => {
        navigate('/addbank');
    };

    const handleEdit = (bankDetail) => {

        navigate("/editbank", { state: { bank: bankDetail, typ: 'EDIT' } });
    };

    const handleCopy = (bankDetail) => {
        navigate("/editbank", { state: { bank: bankDetail, typ: 'COPY' } });
    };

    const handleDelete = (id) => {
        // Open the confirmation modal
        console.log("id >> " + id);
        setBankToDelete(id);
        setShowDeleteModal(true);
    };

    const handleDeleteConfirm = () => {
        console.log("id >> " + bankToDelete);

        deleteBankDataByID(bankToDelete)
            .then((response) => {
                if (response.status === 200 || response.status === 204) {
                    setBank(prevUsers => prevUsers.filter(bank => bank.bankid !== bankToDelete));
                    // setBank((prevBankDetails) =>
                    //     prevBankDetails
                    //         .map((bank) =>
                    //             bank.bankid === bankToDelete ? { ...bank, active: false } : bank
                    //         )
                    //         .filter((bank) => bank.active)
                    // );
                    toast.success("Bank data deleted successfully!", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        style: {
                            border: "3px solid green",
                            borderRadius: "8px",
                            padding: "10px",
                            bottom: "-45px",
                        }
                    });
                } else {
                    toast.error("Failed to delete bank data. Please try again.", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        style: {
                            border: "3px solid red",
                            borderRadius: "8px",
                            padding: "10px",
                            bottom: "-45px",
                        }
                    });
                }
            })
            .catch((error) => {
                console.error("Error deleting bank:", error);
                toast.error("Failed to delete bank data. Please try again.", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    style: {
                        border: "3px solid red",
                        borderRadius: "8px",
                        padding: "10px",
                        bottom: "-45px",
                    }
                });
            });
        // Close the modal after action
        setShowDeleteModal(false);
    };


    const columns = [
        {
            name: "Bank Logo",
            cell: (row) =>
                row.bankLogo ? (
                    <img
                        src={row.bankLogo}
                        alt="Bank Logo"
                        style={{
                            width: "40px",
                            height: "40px",
                            objectFit: "contain",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            padding: "4px",
                        }}
                    />
                ) : (
                    "No Image"
                ),
            sortable: false,
        },
        { name: "Bank Name", selector: (row) => row.bankName, sortable: true },
        { name: "Branch Name", selector: (row) => row.branchName, sortable: true },
        { name: "Address Line-1", selector: (row) => row.address, sortable: true },
        { name: "City", selector: (row) => row.city, sortable: true },
        

                {
                    name: "Invoice Amount",
                    cell: (row) => (
                        <button
                            onClick={() => handleAmountClick("Invoice", row)}
                            className="btn btn-sm btn-light"
                            title="Invoice Amount"
                        >
                            {row.invoiceAmount}
                        </button>
                    ),
                    sortable: true,
                    sortFunction: (rowA, rowB) =>
                        parseFloat(rowA.invoiceAmount) - parseFloat(rowB.invoiceAmount),
                    ignoreRowClick: true,
                    allowOverflow: true,
                },
                {
                    name: "Paid Amount",
                    cell: (row) => (
                        <button
                            onClick={() => handleAmountClick("Paid", row)}
                            className="btn btn-sm btn-light"
                            title="Paid Amount"
                        >
                            {row.paidAmount}
                        </button>
                    ),
                    sortable: true,
                    sortFunction: (rowA, rowB) =>
                        parseFloat(rowA.paidAmount) - parseFloat(rowB.paidAmount),
                    ignoreRowClick: true,
                    allowOverflow: true,
                    button: true,
                },
                {
                    name: "Due Amount",
                    cell: (row) => (
                        <button
                            onClick={() => handleAmountClick("Due", row)}
                            className="btn btn-sm btn-light"
                            title="Due Amount"
                        >
                            {row.dueAmount}
                        </button>
                    ),
                    sortable: true,
                    sortFunction: (rowA, rowB) =>
                        parseFloat(rowA.dueAmount) - parseFloat(rowB.dueAmount),
                    ignoreRowClick: true,
                    allowOverflow: true,
                    button: true,
                },
          
        {
            name: "Actions",
            cell: (row) => (
                <>
                    <button
                        onClick={() => handleEdit(row)}
                        className="btn btn-sm btn-primary me-1"
                        title="Edit Bank"
                    >
                        <FaEdit />
                    </button>
                    <button
                        onClick={() => handleCopy(row)}
                        className="btn btn-sm bg-secondary me-1"
                        title="Copy"
                    >
                        <FaCopy />
                    </button>
                    <button
                        onClick={() => handleDelete(row.bankid)}
                        className="btn btn-sm btn-danger"
                        title="Delete Bank"
                    >
                        <FaRegTrashAlt />
                    </button>
                </>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    // Example function to handle button clicks
    const handleAmountClick = (type, bankDetail) => {
        navigate("/sarfaesibyadmin", { state: { bank: bankDetail } });
    };


    // Conditional row styling
    // Conditional row styling
    const conditionalRowStyles = [
        {
            when: (row) => row.dueAmount > 0, // Condition: Due amount greater than 0
            style: {
                backgroundColor: "rgba(255, 0, 0, 0.2)", // Light red background
                color: "red", // Optional: Change text color
            },
        },
    ];


    return (
        <div className="ShowUsers">
            {loading && <Loading />}
            <div className={`sb-nav-fixed ${isSidebarOpen ? "sb-sidenav-toggled" : ""}`}>
                <TopNav toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
                <div id="layoutSidenav">
                    <SideNave isSidebarOpen={isSidebarOpen} />
                    <div id="layoutSidenav_content">
                        <main>
                            <div className="container-fluid px-4">
                                <h4 className="mt-4">Banks</h4>
                                <hr className="bg-warning" style={{ height: "4px" }} />
                                <div className="mb-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <button
                                                className="btn btn-sm btn-warning me-2"
                                                onClick={handleAdd}
                                            >
                                                <FaPlus /> Add Bank
                                            </button>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <input
                                                type="text"
                                                placeholder="Search..."
                                                className="form-control me-2"
                                                value={searchTerm}
                                                onChange={handleSearch}
                                            />
                                            <button className="btn btn-sm btn-secondary">
                                                <FaSearch />
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className="card mb-4">
                                    <div className="card-body shadow-sm border-0">
                                        <DataTable
                                            className="data-table"
                                            columns={columns}
                                            data={filteredUsers}
                                            conditionalRowStyles={conditionalRowStyles}
                                            pagination
                                            highlightOnHover
                                        />
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </div>

            {/* Confirmation Modal */}
            {showDeleteModal && (
                <div className="modal fade show" style={{ display: 'block' }} onClick={() => setShowDeleteModal(false)}>
                    <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirm Deletion</h5>
                            </div>
                            <div className="modal-body">
                                Are you sure you want to delete this bank data?
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowDeleteModal(false)}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={() => handleDeleteConfirm()}
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ToastContainer */}
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );
}
